/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

// TODO remove negative margin from grid in semantic

export default class Footer extends React.Component {
  getContainerClassNames() {
    const { className, backgroundColor } = this.props;

    return this.isInColorPalette()
      ? `${className && `${className} `}footer-container-${backgroundColor}`
      : '';
  }

  getContainerStyle() {
    const { backgroundColor } = this.props;

    return !this.isInColorPalette() && backgroundColor !== 'none' ? { backgroundColor } : {};
  }

  isInColorPalette() {
    const { backgroundColor } = this.props;

    return backgroundColor === 'primary' || backgroundColor === 'secondary';
  }

  renderFooterColumns() {
    const { columns, verticalAlign, horizontalAlign } = this.props;

    return (
      <Grid
        columns={columns.length}
        verticalAlign={verticalAlign}
        textAlign={horizontalAlign}
        stackable
      >
        {columns.map((column, index) => (
          <Grid.Column key={index}>{column}</Grid.Column>
        ))}
      </Grid>
    );
  }

  render() {
    return (
      <div className={this.getContainerClassNames()} style={this.getContainerStyle()}>
        {this.renderFooterColumns()}
      </div>
    );
  }
}

Footer.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.element),
  horizontalAlign: PropTypes.oneOf(['left', 'center', 'right']),
  verticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
};

Footer.defaultProps = {
  backgroundColor: '',
  className: '',
  columns: [],
  horizontalAlign: 'center',
  verticalAlign: 'middle',
};

Footer.propOptions = {
  backgroundColor: ['primary', 'secondary', 'default'],
};
